import {
	RadioGroupFieldset,
	type RadioGroupFieldsetProps as StyledRadioGroupFieldsetProps,
} from 'components/FormUi';
import { Radio } from 'components/InputUi';
import { slugify } from 'utils/string';

import { useValidatedController } from './hooks';

interface FormOption {
	label: string;
	value: string;
}

interface Props extends Omit<StyledRadioGroupFieldsetProps, 'children' | 'id'> {
	className?: string;
	name: string;
	options: FormOption[];
	requiredErrorMessage?: string;
}

export default function RadioGroup({
	className,
	disabled,
	legend,
	name,
	options,
	required,
	requiredErrorMessage,
	...props
}: Props) {
	const { errorMessage, invalid, onBlur, onChange } = useValidatedController({
		name,
		requiredErrorMessage,
		required,
		disabled,
	});

	return (
		<RadioGroupFieldset
			{...props}
			className={className}
			errorMessage={errorMessage}
			id={name}
			invalid={invalid}
			legend={legend}
			required={required}
		>
			{options.map((option) => (
				<Radio
					key={option.value}
					disabled={disabled}
					onChange={onChange}
					onBlur={onBlur}
					label={option.label}
					value={option.value}
					id={slugify(`${name}-opt-${option.label}`)}
					required={required}
					className="mt-4"
					name={name}
				/>
			))}
		</RadioGroupFieldset>
	);
}
RadioGroup.displayName = 'FinalForm_RadioGroup';
